import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"
import { BikeForSaleType } from "./bike-for-sale-type"

export interface BikeForSaleDefaultManualActionDto {
  id: string
  name: string
  laborPrice: number
  appliesTo: BikeForSaleType[]
}

export const SaveBikeForSaleDefaultManualActionSchema = z.object({
  name: z
    .string()
    .min(1, "common.validation.required" satisfies TranslationKey)
    .max(255),
  laborPrice: z.number().int().min(0),
  appliesTo: z.array(z.nativeEnum(BikeForSaleType)).min(1),
})

export type SaveBikeForSaleDefaultManualAction = z.infer<
  typeof SaveBikeForSaleDefaultManualActionSchema
>
